module.exports = {
  image: 'default.jpg',
  width: '1920',
  height: '1280',
  // TODO: move metadata to gatsby-config
  imageAlt: 'Image of computer screen showing code',
  imageTitleHtml:
    'Photo by <a href="https://unsplash.com/@markusspiske?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Markus Spiske</a> on <a href="https://unsplash.com/s/photos/tech?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a>',
};
